import { SAMLAuthProvider, signInWithRedirect } from "firebase/auth";
import { auth } from "@/lib/firebase/client";

/**
 * Starts a SAML SSO sign-in against an Identity Platform inbound SAML
 * provider (AIR-1261). Same popup-on-localhost / redirect-in-production
 * split as the Google and Microsoft helpers in AuthProvider.tsx (redirect
 * needs the /__/auth handler, which `next dev` doesn't serve); the redirect
 * return is handled by AuthProvider's provider-agnostic getRedirectResult
 * path, which runs the verified server cookie sync exactly like every other
 * provider.
 */
export async function signInWithSSO(providerId: string): Promise<void> {
  const provider = new SAMLAuthProvider(providerId);

  if (typeof window !== "undefined" && window.location.hostname === "localhost") {
    const { signInWithPopup } = await import("firebase/auth");
    await signInWithPopup(auth, provider);
  } else {
    await signInWithRedirect(auth, provider);
  }
}
